import { register } from '../../../Javascript/Utils.js'

import './Hamburger/Hamburger.js'
import './MainNavigation/MainNavigation.js'
import './MenuDrawer/MenuDrawer.js'
import './SearchBar/SearchBar.js'
import './SliderMenu/SliderMenu.js'

const componentPrefix = 'oHeader-'

const Header = el => {
  const headerHeight = document.querySelector(`.${componentPrefix}StickySpacer`).offsetHeight

  if ((window.pageYOffset > headerHeight)) {
    el.classList.add(`${componentPrefix}StickyHeight`)
  }

  document.addEventListener('scroll', () => {
    const headerHeight = document.querySelector(`.${componentPrefix}StickySpacer`).offsetHeight

    if (window.pageYOffset) {
      if ((window.pageYOffset > headerHeight) && !el.classList.contains(`${componentPrefix}OpenByUser`)) {
        el.classList.add(`${componentPrefix}StickyHeight`)
      }
      if (window.pageYOffset <= headerHeight) {
        el.classList.remove(`${componentPrefix}StickyHeight`)
      }
    } else {
      el.classList.remove(`${componentPrefix}OpenByUser`)
      el.classList.remove(`${componentPrefix}StickyHeight`)
    }
  })
}

register('Header', Header)
